import script from "./ImageGallerySlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGallerySlider.vue?vue&type=script&setup=true&lang=js"

import "./ImageGallerySlider.vue?vue&type=style&index=0&id=090bf67a&lang=css"

const __exports__ = script;

export default __exports__